import React, { memo } from 'react';

import classNames from 'classnames';

import { UiButton } from '@shared/ui';

import cls from './CustomerRow.module.css';
import { useCustomerRow } from './useCustomerRow';
import { Icon } from '../../../../../../../components/newUI/Icon/Icon';
import { Select } from '../../../../../../../components/newUI/Select/Select';
import { NotGivenRow } from '../../../UI/NotGivenRow/NotGivenRow';

interface CustomerRowProps {
    classes?: string;
}

export const CustomerRow = memo(({ classes }: CustomerRowProps) => {
    const {
        optionsList,
        selected,
        onSelected,
        onAddCustomer,
        onEditCustomer,
        is_customer,
        can_show_financial_info,
    } = useCustomerRow();
    return (
        <div className={classNames(cls.CustomerRow, [classes])}>
            <span className={cls.title}>{i18next.t('CustomerRow.return.title')}</span>
            {is_customer || !can_show_financial_info ? (
                selected.value ? (
                    <span className={cls.customerTitle}>{selected.title}</span>
                ) : (
                    <NotGivenRow />
                )
            ) : (
                <div className={cls.customerList}>
                    {!optionsList.length ? (
                        <UiButton
                            onClick={onAddCustomer}
                            className={cls.buttonEmptyInfo}
                            variant="text"
                            startIcon={<Icon iconName="plus" />}
                            btnText={i18next.t('CustomerRow.return.button.addCustomer')}
                        />
                    ) : selected.value ? (
                        <UiButton
                            onClick={onEditCustomer}
                            className={cls.buttonShowCustomer}
                            variant="text"
                            startIcon={<span title={selected?.title ?? ''}>{selected.title}</span>}
                        />
                    ) : (
                        <Select
                            title=""
                            options={optionsList}
                            selected={selected}
                            onChange={onSelected}
                            classes={cls.selectCustomer}
                            notAbsolute
                            colorClasses={cls.emptySelect}
                            widthClasses={cls.optionWidth}
                            isEmptyCustomer
                            handleOpenModal={onAddCustomer}
                        />
                    )}
                </div>
            )}
        </div>
    );
});
